<template>
  <svg
    width="10"
    height="14"
    viewBox="0 0 10 14"
  >
    <path d="M5 10.5C5.55228 10.5 6 10.0523 6 9.5C6 8.94771 5.55228 8.5 5 8.5C4.44772 8.5 4 8.94771 4 9.5C4 10.0523 4.44772 10.5 5 10.5ZM5 1.5C4.17157 1.5 3.5 2.17157 3.5 3V5H8.5C9.32843 5 10 5.67157 10 6.5V12.5C10 13.3284 9.32843 14 8.5 14H1.5C0.671573 14 0 13.3284 0 12.5V6.5C0 5.67157 0.671573 5 1.5 5H2.5V3C2.5 1.61929 3.61929 0.5 5 0.5C6.38071 0.5 7.5 1.61929 7.5 3C7.5 3.27614 7.27614 3.5 7 3.5C6.72386 3.5 6.5 3.27614 6.5 3C6.5 2.17157 5.82843 1.5 5 1.5ZM1.5 6C1.22386 6 1 6.22386 1 6.5V12.5C1 12.7761 1.22386 13 1.5 13H8.5C8.77614 13 9 12.7761 9 12.5V6.5C9 6.22386 8.77614 6 8.5 6H1.5Z" />
  </svg>
</template>
